// Daily‑reference ranges for a healthy 19‑50 y adult (min‑max or just min)
export const DRI = {
  fiber_g:        { min: 28 },
  sugars_g:       { max: 50 },             // added sugars upper‑limit
  vitamin_a_mcg:  { min: 700, max: 900 },
  vitamin_b1_mg:  { min: 1.1, max: 1.2 },
  vitamin_b2_mg:  { min: 1.1, max: 1.3 },
  vitamin_b3_mg:  { min: 14,  max: 16 },
  vitamin_b5_mg:  { min: 5  },
  vitamin_b6_mg:  { min: 1.3 },
  vitamin_b7_mcg: { min: 30 },
  vitamin_b9_mcg: { min: 400 },
  vitamin_b12_mcg:{ min: 2.4 },
  vitamin_c_mg:   { min: 75,  max: 90 },
  vitamin_d_mcg:  { min: 20 },
  vitamin_e_mg:   { min: 15 },
  vitamin_k_mcg:  { min: 90,  max: 120 },
  calcium_mg:     { min: 1300 },
  iron_mg:        { min: 18 },
  magnesium_mg:   { min: 320, max: 420 },
  phosphorus_mg:  { min: 1250 },
  potassium_mg:   { min: 4700 },
  sodium_mg:      { max: 2300 },
  zinc_mg:        { min: 8,   max: 11 },
  iodine_mcg:     { min: 150 },
  selenium_mcg:   { min: 55 },
  copper_mg:      { min: 0.9 },
  manganese_mg:   { min: 1.8, max: 2.3 },
  chromium_mcg:   { min: 25,  max: 35 },
  omega_3_mg:     { min: 250, max: 500 },
  omega_6_mg:     { min: 12000, max: 17000 },
  cholesterol_mg: { max: 300 },
  creatine_mg:    null                 // no established DRI
};